import {useMemo} from 'react';

import arSAData from '../mocks/ar-SA/ar-SA.json';
import deDEData from '../mocks/de-DE/de-DE.json';
import enUSData from '../mocks/en-US/en-US.json';
import esESData from '../mocks/es-ES/es-ES.json';
import frFRData from '../mocks/fr-FR/fr-FR.json';
import idIDData from '../mocks/id-ID/id-ID.json';
import itITData from '../mocks/it-IT/it-IT.json';
import jaJPData from '../mocks/ja-JP/ja-JP.json';
import koKRData from '../mocks/ko-KR/ko-KR.json';
import nlNLData from '../mocks/nl-NL/nl-NL.json';
import plPLData from '../mocks/pl-PL/pl-PL.json';
import ptBRData from '../mocks/pt-BR/pt-BR.json';
import roROData from '../mocks/ro-RO/ro-RO.json';
import ruRUData from '../mocks/ru-RU/ru-RU.json';
import thTHData from '../mocks/th-TH/th-TH.json';
import trTRData from '../mocks/tr-TR/tr-TR.json';
import viVNData from '../mocks/vi-VN/vi-VN.json';
import zhCNData from '../mocks/zh-CN/zh-CN.json';
import zhHantTWData from '../mocks/zh-Hant-TW/zh-Hant-TW.json';

// Map locale codes to their corresponding data
// Support both underscore format (en_US) and hyphen format (en-US)
const localeDataMap = {
    'en-US': enUSData,
    en_US: enUSData,
    'ar-SA': arSAData,
    ar_SA: arSAData,
    'zh-CN': zhCNData,
    zh_CN: zhCNData,
    'zh-Hant-TW': zhHantTWData,
    zh_Hant_TW: zhHantTWData,
    'nl-NL': nlNLData,
    nl_NL: nlNLData,
    'fr-FR': frFRData,
    fr_FR: frFRData,
    'de-DE': deDEData,
    de_DE: deDEData,
    'id-ID': idIDData,
    id_ID: idIDData,
    'it-IT': itITData,
    it_IT: itITData,
    'ja-JP': jaJPData,
    ja_JP: jaJPData,
    'ko-KR': koKRData,
    ko_KR: koKRData,
    'pl-PL': plPLData,
    pl_PL: plPLData,
    'pt-BR': ptBRData,
    pt_BR: ptBRData,
    'ro-RO': roROData,
    ro_RO: roROData,
    'ru-RU': ruRUData,
    ru_RU: ruRUData,
    'es-ES': esESData,
    es_ES: esESData,
    'th-TH': thTHData,
    th_TH: thTHData,
    'tr-TR': trTRData,
    tr_TR: trTRData,
    'vi-VN': viVNData,
    vi_VN: viVNData,
} as const;

type LocaleCode = keyof typeof localeDataMap;

// Hook to load locale-specific contentful data for the enriched skills component
export const useLocaleContentfulData = (locale: string) => {
    return useMemo(() => {
        return localeDataMap[locale as LocaleCode] || localeDataMap['en_US'];
    }, [locale]);
};

// Get the contentful data for a specific locale (non-hook version for server-side usage)
export const getLocaleContentfulData = (locale: string) => {
    return localeDataMap[locale as LocaleCode] || localeDataMap['en_US'];
};
